// cookies().set() URL-encodes values, so decode on read to match.
function decodeCookieValue(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function getClientCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie
    .split("; ")
    .find((r) => r.startsWith(`${name}=`));
  return match ? decodeCookieValue(match.slice(name.length + 1)) : undefined;
}

export function hasClientCookie(name: string): boolean {
  return getClientCookie(name) !== undefined;
}

export function getAllClientCookies(): Record<string, string> {
  if (typeof document === "undefined") return {};
  return document.cookie.split("; ").reduce(
    (acc, pair) => {
      const idx = pair.indexOf("=");
      if (idx < 0) return acc;
      acc[pair.slice(0, idx)] = decodeCookieValue(pair.slice(idx + 1));
      return acc;
    },
    {} as Record<string, string>,
  );
}
